import React from 'react';
import { Input, UncontrolledTooltip } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import HelpModal from '../Modals/helpModal';
// import SettingsGuideModal from '../Modals/settingsGuideModal';
import { InfoTag } from '../shared/infoTag';

const DashboardApplicantsCard = ({ statisticsData, onSearch, onNavigate, isAdmin }) => {
  const { t } = useTranslation();

  return (
    <div className="card" data-tut="reactour__applicants">
      <div className="card-body">
        <div className="row">
          <div className="col-6 text-center">
            <br />
            <em
              className="icon-people fa-5x"
              style={{ cursor: 'pointer' }}
              onClick={() => onNavigate('/applicants')}
            ></em>
            {statisticsData?.newApplicants > 0 && (
              <div>
                <br />
                <div
                  style={{ cursor: 'pointer' }}
                  onClick={() => onNavigate('/applicants?onlyNew=1')}
                  className="badge badge-warning"
                >
                  <p className="m-1 h4">
                    <em className="fa fa-star mr-1"></em>
                    <strong>
                      {statisticsData?.newApplicants} {t('applicants.NEW_PL')}
                    </strong>
                  </p>
                </div>
              </div>
            )}
          </div>
          <div className="col-6">
            <h3 className="mt-0">
              {t('applicants.APPLICANTS')}
              &nbsp;
              <HelpModal
                purpose="applicantsHelp"
                showModal={statisticsData?.showHelpApplicantsModal}
                onToggle={() => onNavigate('toggleHelpModal', 'applicantsHelp')}
              />
              {/* <SettingsGuideModal
                showModal={statisticsData?.showSettingsGuideModal}
                onToggle={() => onNavigate('toggleSettingsGuideModal')}
                goToCompanySettings={() => onNavigate('goToCompanySettings')}
                goToUserSettings={() => onNavigate('goToUserSettings')}
                showUserSettings={!statisticsData?.userFirstName || !statisticsData?.userLastName}
                showCompanySettings={!statisticsData?.companyName}
              /> */}
            </h3>
            <ul className="list-unstyled mb-0">
              <li className="mb-1">
                <div className="input-group with-focus">
                  <div className="input-group-prepend">
                    <span className="input-group-text bg-transparent border-right-0">
                      <em className="fa fa-search"></em>
                    </span>
                  </div>
                  <Input
                    type="text"
                    name="text"
                    id="applicantName"
                    data-cy="applicantName"
                    placeholder={t('applicants.SEARCH_BY_NAME')}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        onSearch(e.target.value, 'applicantsName');
                      }
                    }}
                  />
                  <UncontrolledTooltip
                    delay={{ show: 300, hide: 0 }}
                    placement="top"
                    className="badge badge-primary"
                    target="applicantName"
                  >
                    {t('dashboard.TYPE_PRESS_ENTER')}
                  </UncontrolledTooltip>
                </div>
              </li>
              <li className="mb-1">
                <div className="input-group with-focus">
                  <div className="input-group-prepend">
                    <span className="input-group-text bg-transparent border-right-0">
                      <em className="fa fa-search"></em>
                    </span>
                  </div>
                  <Input
                    type="text"
                    name="text"
                    id="applicantSecondName"
                    data-cy="applicantSecondName"
                    placeholder={t('applications.SEARCH_BY_APPLICANT_LAST_NAME')}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        onSearch(e.target.value, 'applicantsSecondName');
                      }
                    }}
                  />
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="card-body bg-inverse" onClick={() => onNavigate('/applicants')} style={{ cursor: 'pointer' }}>
        <div className="row text-center">
          <div className="col-4">
            <p className="m-0 h3">{statisticsData?.numApplicants}</p>
            <p className="m-0">
              {t('applicants.ALL')}
              &nbsp;
              <InfoTag id="allApplicants" lng={t('i18n.language')} />
            </p>
          </div>
          <div className="col-4" id="colNumOpenApplicants">
            <p className="m-0 h3">{statisticsData?.numOpenApplicants}</p>
            <p className="m-0">
              {t('applicants.OPEN')}
              &nbsp;
              <InfoTag id="openApplicants" lng={t('i18n.language')} />
            </p>
          </div>
          <div className="col-4" id="colNumBoundedApplicants">
            <p className="m-0 h3">{statisticsData?.numBoundedApplicants}</p>
            <p className="m-0">
              {t('applicants.BOUNDED')}
              &nbsp;
              <InfoTag id="boundedApplicants" lng={t('i18n.language')} />
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardApplicantsCard;
